import {doc} from './docs.js';
import ZButtonPresser from '../custom/ZButtonPresser.js';

doc(
    "buttonPresser",
    {
    },
    "Sends a bang thru one outlet on press and thru another one release",
    () => 0,
    {
        inlets: 0
    }
);
export const buttonPresser = (object) => {
    const o = new ZButtonPresser(object);
    object.newAttribute("button-color", "#ffffff");
    object.width = 50;
    object.height = 50;
    return () => undefined;
};
